const BASE_ACTION_TYPE = 'LANDLORD::MAINTENANCE::SERVICE_REQUESTS';

export const FETCH_RESIDENTS = `${BASE_ACTION_TYPE}::FETCH_RESIDENTS`;
export const POST_INTERNAL_COMMENT = `${BASE_ACTION_TYPE}::POST_INTERNAL_COMMENT`;
